// extracted by mini-css-extract-plugin
export default {"dot-flashing":"ProgressDots_dot-flashing__TpIER"};